import { render } from "./EvvDetails.vue?vue&type=template&id=3760d9dc"
import script from "./EvvDetails.ts?vue&type=script&lang=js&external"
export * from "./EvvDetails.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__